import axios from 'axios';

const serverUrl = 'http://195.35.6.154:8080/ai-mock-interview/';

const API = axios.create({
    baseURL: "/api/interview"
});
const SUB_API = axios.create({
    baseURL: "/api/subscription"
});

export const startInterview  = (data)     => API.post('/start', data);
export const submitAnswer    = (data)     => API.post('/answer', data);
export const endSession      = (data)     => API.post('/end', data);
export const registerUser  = (data)   => SUB_API.post('/register', data);
export const getUserStatus = (userId) => SUB_API.get(`/status/${userId}`);
export const activatePlan  = (data)   => SUB_API.post('/activate', data);
export const cancelPlan    = (data)   => SUB_API.post('/cancel', data);
// ── History (new DB-backed endpoints) ──
export const getPaymentHistory = (userId) => SUB_API.get(`/payments/${userId}`);
export const getSessionHistory = (userId) => SUB_API.get(`/sessions/${userId}`);
export const abandonSession = (data) => API.post('/abandon', data);
export const createPaymentOrder  = (data) => SUB_API.post('/create-order', data);
export const verifyPayment       = (data) => SUB_API.post('/verify-payment', data);

export const transcribeAudio = (audioBlob) => {
  const form = new FormData();
  form.append('audio', audioBlob, 'recording.webm');
  return API.post('/transcribe', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  
};
